<template>
    <div id="easy_event_selection">
        <EspSnackbar v-model="snackbarShow" :color="snackbarColor" :text="snackbarText" :timeout="6000"/>
        <v-card flat>
            <v-card-title primary-title class="justify-center">
                <img :src="`${this.customBasePath}/logo.png`" style="max-width:100%;max-height:60px"/>
            </v-card-title>
            <v-card-subtitle class="text-center pb-0">
                <div class="pt-6 headline font-weight-light">{{ $t('easyEventTitle', { event: $tc('event', 1) }) }}</div>
            </v-card-subtitle>
            <v-card-text>
                <v-container>
                    <p class="text-center">{{ $t('easyEventMessage', { eventInLine: $tc('eventInLine', 1), eventList: $t('eventList') }) }}</p>

                    <!-- Main event -->
                    <v-row v-if="cardShowsMainEvent" justify="center" no-gutters>
                        <v-col cols="12" align="center" class="pa-2">
                            <v-btn :color="theme.buttonGreen" large block depressed rounded dark class="main-event-btn" :loading="event_single_loading" @click="onMainEvent">
                                {{ mainEventLabel }}
                            </v-btn>
                        </v-col>
                    </v-row>

                    <!-- Event list -->
                    <v-row justify="center" no-gutters class="mb-2">
                        <v-col cols="12" align="center" class="pa-2">
                            <v-btn color="grey lighten-1" large block depressed rounded dark @click="$emit('list')">
                                {{ $t('easyEventGoToList', { eventList: $t('eventList') }) }}
                            </v-btn>
                        </v-col>
                    </v-row>

                    <!-- PIN / QR -->
                    <template v-if="cardShowsScan">
                        <hr>
                        <p class="mt-4">{{ $t('easyEventAlternative', { eventInLine: $tc('eventInLine', 1) }) }}</p>
                        <v-row>
                            <v-col v-if="!disablePINAccess">
                                <EspButtonPinCheckin @success="onCodeReceived" :disabled="false"/>
                            </v-col>
                            <v-col v-if="!disableQRAccess">
                                <EspButtonQrCheckin
                                    :spot="null"
                                    icon="mdi-qrcode"
                                    :label="$t('qrCode')"
                                    :fctIsValidCode="isScannedCodeValid"
                                    :disabled="false"
                                    @success="onCodeReceived"
                                />
                            </v-col>
                        </v-row>
                    </template>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import {layoutMixin} from "../../utils/layout-mixin";
import {settingsMixin} from "../../utils/settings-mixin";
import {eventMixin} from "../../utils/event-mixin";
import {qrLoginMixin} from "../../utils/qrlogin-mixin";
import {qrJoinMixin} from "../../utils/qr-join-mixin";
import {onboardingMixin} from "../../utils/onboarding-mixin";
import EspButtonQrCheckin from "../spots/EspButtonQrCheckin";
import EspButtonPinCheckin from "../auth/EspButtonPinCheckin.vue";
import EspSnackbar from "../ui/EspSnackbar.vue";

export default {
    mixins: [settingsMixin, layoutMixin, eventMixin, qrLoginMixin, qrJoinMixin, onboardingMixin],
    components: {
        EspButtonQrCheckin,
        EspButtonPinCheckin,
        EspSnackbar
    },
    data: () => ({
        snackbarShow: false,
        snackbarText: '',
        snackbarColor: 'error'
    }),
    computed: {
        mainEventLabel() {
            return this.mainEventName || this.$t('easyEventMain');
        }
    },
    created() {
        // settings are persisted, but a fresh browser profile may open this page before getplayer ran
        if (!this.mainEventId) {
            this.loadAppSettings();
        }
    },
    methods: {
        onMainEvent() {
            this.$emit('next', this.mainEventId);
        },
        onCodeReceived(qrData) {
            const errorKey = this.handleScannedQr(qrData);
            if (errorKey) {
                this.showSnackbarError(this.$t(errorKey));
            }
        },
        showSnackbarError(message) {
            this.snackbarText = message;
            this.snackbarColor = 'error';
            this.snackbarShow = true;
        }
    }
}
</script>

<style lang="scss">
#easy_event_selection {
    // a long event name wraps inside the button instead of widening the card
    .main-event-btn {
        height: auto;
        min-height: 44px;
        white-space: normal;

        .v-btn__content {
            flex-shrink: 1;
            max-width: 100%;
            padding: 8px 0;
        }
    }
}
</style>
